import { useCallback, useState } from 'react';
import type { ViewMode } from '@/lib/requests';

// Vista (griglia/lista) condivisa fra le liste di richieste e itinerari. Come per la
// sidebar, la scelta resta nel localStorage e vale anche alle sessioni successive.
const DEFAULT_VIEW_DASHBOARD_STORAGE_KEY = 'defaultViewDashboard';
const FALLBACK_VIEW_MODE: ViewMode = 'grid';

const readDefaultViewDashboard = (): ViewMode => {
  try {
    const saved = localStorage.getItem(DEFAULT_VIEW_DASHBOARD_STORAGE_KEY);
    return saved === 'grid' || saved === 'list' ? saved : FALLBACK_VIEW_MODE;
  } catch {
    return FALLBACK_VIEW_MODE;
  }
};

export const useDashboardViewMode = () => {
  const [viewMode, setViewModeState] = useState<ViewMode>(readDefaultViewDashboard);

  const setViewMode = useCallback((mode: ViewMode) => {
    setViewModeState(mode);
    try {
      localStorage.setItem(DEFAULT_VIEW_DASHBOARD_STORAGE_KEY, mode);
    } catch {
      // storage non disponibile (es. navigazione privata): la scelta vale solo per la sessione
    }
  }, []);

  return [viewMode, setViewMode] as const;
};
